/* eslint-disable no-underscore-dangle */
import actions from './actions'

const initialState = {
  smsData: null,
  userProfile: null,
  searchSMS: null,
  loading: false,
  creating: false,
  updating: false,
  removing: false,
  displayAddSMSkDrawer: false,
}

export default function smsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.SHOW_CREATE:
      return { ...state, displayAddSMSkDrawer: true }
    case actions.HIDE_CREATE:
      return { ...state, displayAddSMSkDrawer: false }

    default:
      return state
  }
}
